import { render, staticRenderFns } from "./RentObjectBookingExtras.vue?vue&type=template&id=2d61639a&scoped=true&lang=pug"
import script from "./RentObjectBookingExtras.vue?vue&type=script&lang=js"
export * from "./RentObjectBookingExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61639a",
  null
  
)

export default component.exports